export function mutateSearchParams(
  mutator: (searchParams: URLSearchParams) => void,
): URLSearchParams {
  const searchParams = new URLSearchParams(window.location.search);

  mutator(searchParams);

  return searchParams;
}
